import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=1ad8f54e&scoped=true"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"
import style0 from "./EventsView.vue?vue&type=style&index=0&id=1ad8f54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8f54e",
  null
  
)

export default component.exports